// import { default as state, CONSTANTS as STATE_CONSTANTS } from './state'
import CONSTANTS from './constants'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

// export const getModule = ({ Echo }) => {
//   // state[STATE_CONSTANTS.CONNECTION_STATE] = bindConnectionState(Echo)
//   return {
//     namespaced: true,
//     state,
//     getters,
//     mutations,
//     actions,
//   }
// }
export const WS_CONSTANTS = CONSTANTS

export const WS_MODULE = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
